<template>
  <div
    class="relative flex flex-col items-center bg-[#001F3D] text-sm text-white text-nowrap"
  >
    <div class="overlay absolute top-0 left-0 w-full h-full"></div>
    <footer class="w-full min-[1200px]:w-4/5 max-[1199px]:px-5 z-10">
      <div class="flex max-md:flex-col py-5 max-md:gap-5">
        <div class="w-3/4">
          <h6 class="uppercase mb-3">Contact</h6>
          <ul
            class="flex max-md:flex-col justify-between gap-5 md:gap-10 mr-20 space-y-1"
          >
            <li class="flex flex-col gap-1">
              <a
                v-for="phone in phoneList"
                :key="phone.id"
                :href="`tel:${phone.information}`"
                class="flex items-center gap-1"
              >
                <font-awesome-icon icon="fa-solid fa-phone" />
                {{ phone.information }}
              </a>
            </li>

            <li class="flex flex-col gap-1">
              <a
                v-for="email in emailList"
                :key="email.id"
                :href="`mailto:${email.information}`"
                class="flex items-center gap-1"
              >
                <font-awesome-icon icon="fa-solid fa-envelope" />
                {{ email.information }}
              </a>
            </li>

            <li class="flex flex-col gap-1">
              <a
                v-for="link in linkList"
                :key="link.id"
                :href="`https://${link.information}`"
                target="_blank"
                class="flex items-center gap-1"
              >
                <font-awesome-icon icon="fa-solid fa-globe" />
                {{ link.information }}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h6 class="uppercase mb-3">Social media</h6>
          <div class="flex items-center gap-2">
            <a
              href="https://www.facebook.com/miningweek"
              target="_blank"
              class="flex justify-center items-center w-8 h-8 rounded-full border hover:bg-[#00a375]"
            >
              <font-awesome-icon icon="fa-brands fa-facebook-f" />
            </a>
            <a
              href="https://www.instagram.com/miningweek"
              target="_blank"
              class="flex justify-center items-center w-8 h-8 rounded-full border hover:bg-[#00a375]"
            >
              <font-awesome-icon icon="fa-brands fa-instagram" />
            </a>
            <a
              href="https://twitter.com/mining_week"
              target="_blank"
              class="flex justify-center items-center w-8 h-8 rounded-full border hover:bg-[#00a375]"
            >
              <font-awesome-icon icon="fa-brands fa-x-twitter" />
            </a>
            <a
              href="https://www.linkedin.com/company/mongolian-national-mining-association"
              target="_blank"
              class="flex justify-center items-center w-8 h-8 rounded-full border hover:bg-[#00a375]"
            >
              <font-awesome-icon icon="fa-brands fa-linkedin-in" />
            </a>
          </div>
        </div>
      </div>

      <div class="border-t border-[#009269] text-center py-5">
        <a href="https://bowsys.mn" target="_blank" class="hover:underline"
          >Copyright by &copy; BOW LLC - 2024</a
        >
      </div>
    </footer>
  </div>
</template>

<script>
import { ref, computed } from "vue";

export default {
  name: "MW2023Footer",
  setup() {
    const footerInfo = ref([
      {
        type: "phone",
        information: "+976 7011 0163",
      },
      {
        type: "phone",
        information: "+976 8888 9878",
      },
      {
        type: "email",
        information: "miningweek@miningmongolia.mn",
      },
      {
        type: "email",
        information: "info@miningmongolia.mn",
      },
      {
        type: "link",
        information: "www.miningmongolia.mn",
      },
      {
        type: "link",
        information: "www.mmhi.gov.mn",
      },
    ]);

    const phoneList = computed(() => {
      return footerInfo.value.filter((item) => item.type === "phone");
    });
    const emailList = computed(() => {
      return footerInfo.value.filter((item) => item.type === "email");
    });
    const linkList = computed(() => {
      return footerInfo.value.filter((item) => item.type === "link");
    });

    return { phoneList, emailList, linkList };
  },
};
</script>

<style scoped>
.overlay {
  background-image: url("@/assets/images/miningWeek/diagonalstripe-black.png");
}
</style>
